import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { InputCheckboxComponent } from '../../inputs/input-checkbox/input-checkbox.component';
import { SvgComponent } from '../../svg/svg.component';
import { CollaboraterRole } from '@app/_types/generic.type';
import { SettingsService } from '@app/_services/settings.service';
import { MapService } from '@app/_services/map.service';
import { AnalyticsService } from '@app/_services/analytics.service';

@Component({
    selector: 'app-filter-role',
    imports: [
        CommonModule,
        MatMenuModule,
        SvgComponent,
        InputCheckboxComponent
    ],
    templateUrl: './filter-role.component.html',
    styleUrl: './filter-role.component.scss'
})

export class FilterRoleComponent implements OnInit {

  @Input() value: WritableSignal<CollaboraterRole[]> = signal<CollaboraterRole[]>([]);
  @Input() multiple: boolean = false;
  @Input() label: string = '';
  @Input() hiddenValues: CollaboraterRole[] = [];
  entityFilterRole: CollaboraterRole[] = ['viewer', 'editor', 'owner'];
  entityRoleMap: Signal<Record<CollaboraterRole, string>> = this.mapService.collaboratorRoleMap;
  valueToIconMap: Record<CollaboraterRole, string> = {
    owner: 'user',
    editor: 'edit',
    viewer: 'view',
  };

  // Local optimistic state — updates instantly on click, independent of store propagation
  selectedItems = signal<CollaboraterRole[]>([]);

  constructor(public ss: SettingsService, private mapService: MapService, private as: AnalyticsService) {

  }

  ngOnInit(): void {
    this.selectedItems.set(this.value());
  }

  getLabel(): string {
    if (this.selectedItems().length === 0) {
      return this.ss.t('common_access');
    } else if (this.selectedItems().length === 1) {
      return this.entityRoleMap()[this.selectedItems()[0]];
    } else {
      return this.selectedItems().length + ' ' + this.ss.t('common_access');
    }
  }

  onRoleSelected(value: CollaboraterRole, event: MouseEvent): void {
    if (this.multiple) {
      const current = this.selectedItems();
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      // Update local state immediately (optimistic)
      this.selectedItems.set(updated);
      // Update store — triggers data reload in background
      this.value.set(updated);
      event.stopPropagation();
    } else {
      this.selectedItems.set([value]);
      this.value.set([value]);
    }
    this.as.filterEvent('role', value);
  }

}
